import { EditorView } from "codemirror";
import { HighlightStyle, syntaxHighlighting } from '@codemirror/language'
import { tags } from '@lezer/highlight'

// TunePadDark theme based on 
// Using https://github.com/one-dark/vscode-one-dark-theme/ as reference for the colors
const chalky = "#e5c07b"
const coral = "#e06c75"
const cyan = "#56b6c2"
const invalid$1 = "#ffffff"
const ivory = "#abb2bf"
const stone = "#7d8799"
const malibu = "#61afef"
const sage = "#98c379"
const whiskey = "#d19a66"
const violet = "#f6b"
const darkBackground$1 = "#21252b"
const highlightBackground$1 = "#2c313a"
const background$1 = "transparent"; //"#2E303F"
const tooltipBackground$1 = "transparent"; //"#353a42"
const selection$1 = "rgb(56 69 99)";
const cursor$1 = "#528bff"


const tunePadDarkTheme = EditorView.theme({
    "&": {
        color: ivory,
        backgroundColor: background$1
    },
    ".cm-content": {
        caretColor: cursor$1
    },
    ".cm-cursor, .cm-dropCursor": { borderLeftColor: cursor$1 },
    "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": { backgroundColor: selection$1 },
    ".cm-panels": { backgroundColor: darkBackground$1, color: ivory },
    ".cm-panels.cm-panels-top": { borderBottom: "2px solid black" },
    ".cm-panels.cm-panels-bottom": { borderTop: "2px solid black" },
    ".cm-searchMatch": {
        backgroundColor: "#72a1ff59",
        outline: "1px solid #457dff"
    },
    ".cm-searchMatch.cm-searchMatch-selected": {
        backgroundColor: "#6199ff2f"
    },
    ".cm-activeLine": { backgroundColor: selection$1 },
    ".cm-selectionMatch": { backgroundColor: "#aafe661a" },
    "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bad0f847"
    },
    ".cm-gutters": {
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        color: stone,
        paddingLeft: '5px',
        border: "none",
        borderRight: '1px solid #fff2'
    },
    ".cm-activeLineGutter": {
        backgroundColor: 'transparent'
    },
    ".cm-foldPlaceholder": {
        backgroundColor: "transparent",
        border: "none",
        color: "#ddd"
    },
    ".cm-tooltip": {
        border: "none",
        backgroundColor: tooltipBackground$1,
        color: "#222"
    },
    ".cm-tooltip .cm-tooltip-arrow:before": {
        borderTopColor: "transparent",
        borderBottomColor: "transparent"
    },
    ".cm-tooltip .cm-tooltip-arrow:after": {
        borderTopColor: tooltipBackground$1,
        borderBottomColor: tooltipBackground$1
    },
    ".cm-tooltip-autocomplete": {
        "& > ul > li[aria-selected]": {
            backgroundColor: "#d9def5", //highlightBackground$1,
            color: "#222" //ivory
        }
    }
}, { dark: true });

/**
The highlighting style for code in the One Dark theme.
*/
const tunePadDarkHighlightStyle = HighlightStyle.define([
    {
        tag: tags.keyword,
        color: violet
    },
    {
        tag: [tags.name, tags.deleted, tags.character, tags.propertyName, tags.macroName],
        color: coral
    },
    {
        tag: [/*@__PURE__*/tags.function(tags.variableName), tags.labelName],
        color: '#2f9ff7' // malibu
    },
    {
        tag: [tags.color, /*@__PURE__*/tags.constant(tags.name), /*@__PURE__*/tags.standard(tags.name)],
        color: '#2f9ff7' //whiskey
    },
    {
        tag: [/*@__PURE__*/tags.definition(tags.name), tags.separator],
        color: 'rgba(233, 237, 237, 1)' //ivory
    },
    {
        tag: [tags.typeName, tags.className, tags.number, tags.changed, tags.annotation, tags.modifier, tags.self, tags.namespace],
        color: '#e3595f' //chalky
    },
    {
        tag: [tags.operator, tags.operatorKeyword, tags.url, tags.escape, tags.regexp, tags.link, /*@__PURE__*/tags.special(tags.string)],
        color: '#fff' //cyan
    },
    {
        tag: [tags.meta, tags.comment],
        color: '#9797a7' //stone
    },
    {
        tag: tags.strong,
        fontWeight: "bold"
    },
    {
        tag: tags.emphasis,
        fontStyle: "italic"
    },
    {
        tag: tags.strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: tags.link,
        color: stone,
        textDecoration: "underline"
    },
    {
        tag: tags.heading,
        fontWeight: "bold",
        color: coral
    },
    {
        tag: [tags.atom, tags.bool, /*@__PURE__*/tags.special(tags.variableName)],
        color: '#e3595f' //whiskey
    },
    {
        tag: [tags.processingInstruction, tags.string, tags.inserted],
        color: '#C3E88D' //sage
    },
    {
        tag: tags.invalid,
        color: invalid$1
    },
]);
/**
Extension to enable the One Dark theme (both the editor theme and
the highlight style).
*/
export const tunePadDark = [tunePadDarkTheme, syntaxHighlighting(tunePadDarkHighlightStyle)];
